import React, { useEffect, useState } from 'react';

const SnowfallEffect = () => {
    const [snowflakes, setSnowflakes] = useState([]);
    const [santaFlying, setSantaFlying] = useState(false);
    const [santaTop, setSantaTop] = useState(20);

    useEffect(() => {
        // Generate snowflakes
        const flakes = [];
        const count = 80; // Number of snowflakes

        for (let i = 0; i < count; i++) {
            flakes.push({
                id: i,
                left: Math.random() * 100, // Random horizontal position (%)
                animationDuration: 5 + Math.random() * 10, // Fall duration (5-15s)
                animationDelay: Math.random() * 5, // Start delay (0-5s)
                size: 2 + Math.random() * 4, // Size (2-6px)
                opacity: 0.3 + Math.random() * 0.7, // Opacity (0.3-1)
                drift: -20 + Math.random() * 40, // Horizontal drift (-20 to 20px)
            });
        }

        setSnowflakes(flakes);

        // Santa (Christmas Thatha) Flight scheduler
        const triggerSantaFlight = () => {
            if (!santaFlying) {
                setSantaTop(10 + Math.random() * 30); // 10% to 40% vertical height
                setSantaFlying(true);
                setTimeout(() => {
                    setSantaFlying(false);
                }, 12000); // Matches CSS transition duration
            }
        };

        // Fly Santa once shortly after mounting (5s), then repeat every 25 seconds
        const firstFlight = setTimeout(triggerSantaFlight, 5000);
        const flightInterval = setInterval(triggerSantaFlight, 25000);

        return () => {
            clearTimeout(firstFlight);
            clearInterval(flightInterval);
        };
    }, [santaFlying]);

    return (
        <div className="snowfall-container">
            {/* Flying Santa Claus (Christmas Thatha) */}
            {santaFlying && (
                <div
                    className="flying-santa"
                    style={{ '--santa-top': `${santaTop}%` }}
                >
                    🎅🛷🦌🦌✨
                </div>
            )}

            {snowflakes.map((flake) => (
                <div
                    key={flake.id}
                    className="snowflake"
                    style={{
                        left: `${flake.left}%`,
                        width: `${flake.size}px`,
                        height: `${flake.size}px`,
                        opacity: flake.opacity,
                        animationDuration: `${flake.animationDuration}s`,
                        animationDelay: `${flake.animationDelay}s`,
                        '--drift': `${flake.drift}px`,
                    }}
                >
                    ❄
                </div>
            ))}
        </div>
    );
};

export default SnowfallEffect;
